import { useSelector } from 'react-redux';

export function useSessionData() {
  return useSelector(state => state.session.data);
}


export function useUserCountry() {
  const sessionData = useSessionData();
  return (sessionData.userType && sessionData.userType.type) || null;
}

export function useCurrentUser() {
  return useSelector(state => state.session.user);
}
